export default __webpack_public_path__ + "static/media/pc2.38e1c575.jpg";